import SoopUiCalender from '@/components/ui/soop-ui-date-picker/SoopUiCalender';
import SoopUiDateInput from '@/components/ui/soop-ui-date-picker/SoopUiDateInput';
import {format, isSameDay} from 'date-fns';
import {forwardRef, useEffect, useImperativeHandle, useState} from 'react';

// 날짜 포맷팅 유틸리티 함수들을 분리
const formatSingleDate = (date) => (date ? format(date, 'yyyy.MM.dd') : '');

const formatDateRange = (start, end) => {
  if (!start || !end) {
    return '';
  }

  // 시작일과 종료일이 같은 경우 단일 날짜로 표시
  if (isSameDay(start, end)) {
    return formatSingleDate(start);
  }

  return `${formatSingleDate(start)} ~ ${formatSingleDate(end)}`;
};

/**
 * SoopUiDatePicker 컴포넌트
 * @desc 날짜 선택 가능한 데이트피커
 * // TODO example 요소 추가하기
 **/

const SoopUiDatePicker = forwardRef(
  ({startDate, endDate, handleDateSelected}, ref) => {
    const [applyStatus, setApplyStatus] = useState(false); // 적용 버튼 클릭 여부
    const [isCalendarActive, setIsCalendarActive] = useState(false); // 달력 open 유무
    const [isDateRangeSelected, setIsDateRangeSelected] = useState([0, 0]); // 날짜 선택 유무[시작일, 종료일] 0: 선택 1: 미선택
    const [dateRange, setDateRange] = useState([
      {
        startDate: '',
        endDate: '',
        key: 'selection',
        applyStatus: true,
      },
    ]);
    const [selectedPeriod, setSelectedPeriod] = useState('');

    // 포커스가 변경될 때 호출되는 함수
    const handleRangeFocusChange = (newFocusedRange) => {
      setIsDateRangeSelected(newFocusedRange); // 새로운 포커스 상태를 업데이트
    };

    useImperativeHandle(ref, () => ({
      open: () => setIsCalendarActive(true),
      close: () => setIsCalendarActive(false),
    }));

    const handleCalendarOpen = () => {
      setIsCalendarActive(true);
      handleRangeFocusChange([0, 0]);
    };

    useEffect(() => {
      const formattedDate = isCalendarActive
        ? ''
        : formatDateRange(startDate, endDate);

      setSelectedPeriod(formattedDate);
    }, [isCalendarActive, startDate, endDate]);

    const datePickerProps = {
      selectedPeriod,
      startDate,
      endDate,
      isCalendarActive,
      applyStatus,
      handleDateSelected,
      isDateRangeSelected,
      dateRange,
      handleApplyStatus: setApplyStatus,
      handleCalendarClosed: () => setIsCalendarActive(false),
      handleIsDateRangeSelected: setIsDateRangeSelected,
      handleRangeFocusChange,
      handleCalendarOpen,
      handleDateRange: setDateRange,
    };

    return (
      <div className='calendal_wrap'>
        <SoopUiDateInput {...datePickerProps} />
        {isCalendarActive && <SoopUiCalender {...datePickerProps} />}
      </div>
    );
  },
);

// displayName 추가
SoopUiDatePicker.displayName = 'SoopUiDatePicker';

export default SoopUiDatePicker;
